import type { Theme } from "@mui/material";
import { Box, Typography, useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useScrollEvent } from "@entrilia/shared/hooks/useScrollEvent";
import useClientContext from "../../contexts/useClientContext";
import DefaultBannerImage from "../../images/default_banner.png";

const Banner = () => {
  const { portalSettings, clientTitle, contactName } = useClientContext();

  const pageOffset = useScrollEvent({ sensitivity: 30 });
  const isTabletOrLower = useMediaQuery((theme: Theme) => theme.breakpoints.down("lg"));
  const theme = useTheme();

  if (isTabletOrLower) {
    return null;
  }

  const shrinkBanner = pageOffset > 100;

  const imageSrc = portalSettings?.bannerUrl || DefaultBannerImage;

  const bannerFontColor =
    portalSettings?.bannerFontColor || theme.palette.primary.contrastText || theme.palette.text.primary;

  return (
    <Box
      sx={(theme) => ({
        position: "sticky",
        top: theme.spacing(7),
        left: 0,
        py: theme.spacing(shrinkBanner ? 2 : 3),
        px: theme.spacing(5),
        width: "100%",
        backgroundImage: `url(${imageSrc})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundColor: theme.palette.common.white,
        transition: "0.2s",
        zIndex: 999,
        maxHeight: "120px",
      })}
    >
      <Typography variant={shrinkBanner ? "h4" : "h3"} sx={{ color: bannerFontColor }}>
        {contactName}
      </Typography>
      <Typography variant={shrinkBanner ? "h6" : "h5"} sx={{ color: bannerFontColor, fontWeight: 500 }}>
        {`Welcome to the ${clientTitle} Investor Portal`}
      </Typography>
    </Box>
  );
};

export default Banner;
